import s from "./RollingSubmissionDetail.module.css";

export const STATUS_BADGE_CLASS: Record<string, string> = {
  publish: s.statusBadgePublish,
  pending_review: s.statusBadgePending,
  pending: s.statusBadgePending,
  draft: s.statusBadgeDraft,
  trash: s.statusBadgeTrash,
};

export const STATUS_SELECT_CLASS: Record<string, string> = {
  publish: s.statusSelectPublish,
  pending_review: s.statusSelectPending,
  pending: s.statusSelectPending,
  draft: s.statusSelectDraft,
  trash: s.statusSelectTrash,
};

export const STATUS_BADGE_LABELS: Record<string, string> = {
  publish: "Publish",
  pending: "Pending",
  draft: "Draft",
  trash: "Trash",
};
